/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Edit_No_ChangesInputs */



/**
* | output |
* | --- |
* | "No changes were proposed for this document." |
*
* @param {Artifact_Edit_No_ChangesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_edit_no_changes = /** @type {((inputs?: Artifact_Edit_No_ChangesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Edit_No_ChangesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für dieses Dokument wurden keine Änderungen vorgeschlagen.")
	return /** @type {LocalizedString} */ ("No changes were proposed for this document.")
});